import React from 'react';

import Groupbox from '../core/Groupbox';
import HostsInput from './HostsInput';
//import HostsTable from './HostsTable';
import HostsTable2 from './HostsTable2';
import Validation from './Validation';
import { isOverlay, getNotation } from './iput/src/helper';

function removeFromArray(items, item) {
    var index = items.indexOf(item);
    if (index >= 0) {
        items.splice(index, 1);
    }
}

export default class HostsTab extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            includeSelected: null, excludeSelected: null, format: null, value: null,
        isValid:false};

        this.checkOverlay = this.checkOverlay.bind(this);
        this.checkOverlayAll = this.checkOverlayAll.bind(this);
    }
    checkOverlay(toAdd, target) {
        if (isOverlay(toAdd, target)) {
            return `${toAdd} is overlay with ${target}`;
        } else {
            return null;
        }
    }
    checkOverlayAll(toAdd, targetArray) {
        for (let target of targetArray) {
            const overlayCheck = this.checkOverlay(toAdd, target);
            if (overlayCheck) {
                return overlayCheck;
            }
        }

        return null;
    }
    onEvent(ribbonTitle, groupTitle, itemTitle) {
        const { include, exclude } = this.props;
        const { includeSelected, excludeSelected, value, isValid } = this.state;
        if (groupTitle === 'IP Entry Format') {
            this.setState({ format: itemTitle, value: null });
        }else if(groupTitle === 'Apply Entry'){
            if (itemTitle === 'Add') {
                if (!isValid) {
                    alert('Not valid');
                    return;
                }
                if (value) {
                    const overlayCheck = this.checkOverlayAll(value, include);
                    if (overlayCheck) {
                        alert(overlayCheck);
                    } else {
                        include.push(value);
                        this.onChange(include, exclude);
                    }
                }
            } else if (itemTitle === 'Exclude') {
                if (!isValid) {
                    alert('Not valid');
                    return;
                }
                if (value) {
                    const overlayCheck = this.checkOverlayAll(value, exclude);
                    if (overlayCheck) {
                        alert(overlayCheck);
                    } else {
                        exclude.push(value);
                        this.onChange(include, exclude);
                    }
                }
            } else if (itemTitle === 'Delete') {
                if (includeSelected) {
                    removeFromArray(include, includeSelected);
                } else if (excludeSelected) {
                    removeFromArray(exclude, excludeSelected);
                }

                this.onChange(include, exclude);
            }
        }
    }
    onChange(include, exclude) {
        this.setState({ include, exclude });
        if (this.props.onChange) {
            this.props.onChange(include, exclude);
        }
    }
    render() {
        const { include, exclude } = this.props;
        const { includeSelected, excludeSelected, format, value } = this.state;
        return (
            <div style={{ margin: '2px', fontSize: '.8em', display: 'flex' }}>
                <div style={{ width: '500px' }}>
                    <HostsInput format={format} value={value}
                        ref={ref => this.hostsInput = ref} onChange={(format, value) => {
                            this.setState({ format, value });
                            this.validator.run(format,value);
                        }
                            } />
                    <Validation format={format} ref={ref => this.validator = ref}
                        value={value}
                        onValidate={isValid => this.setState({ isValid })} />
                </div>
                
                <div style={{width:'700px'}}>
                    <Groupbox header='Include'>
                        <HostsTable2 selected={includeSelected}
                            onSelect={row => {
                                const notation = getNotation(row);
                                this.setState({ includeSelected: row, excludeSelected:null })
                            }}
                            data={include} />
                    </Groupbox>
                    <Groupbox header='Exclude'>
                        <HostsTable2 selected={excludeSelected}
                            onSelect={row => {
                                const notation = getNotation(row);
                                this.setState({ includeSelected: null, excludeSelected:row })
                            }}
                            data={exclude} />
                    </Groupbox>
                </div>
            </div>
        );
    }
}